<style src="./TopWave.scss" lang="scss" scoped></style>

<template src="./TopWave.html" />

<script>
export default {
  name: 'TopWave',
};
</script>
